
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

/** 时间格式 - ("YYYY-MM-DD HH:mm:ss") */
export const YYYYMMDDHHmmss = 'YYYY-MM-DD HH:mm:ss'

/** 时间格式 - ("YYYY-MM-DD HH:mm") */
export const YYYYMMDDHHmm = 'YYYY-MM-DD HH:mm'

/** 时间格式 - ("MM-DD HH:mm") */
export const MMDDHHmm = 'MM-DD HH:mm'

/** 时间格式 - ("YYYY-MM-DD") */
export const YYYYMMDD = 'YYYY-MM-DD'

export const YYYYMM = 'YYYY-MM'
export const getUnixTime = (time = Date.now()) => {
  return Math.floor(time / 1000)
}

export const getMsTime = (time: number) => {
  return time * 1000
}

/**
 * 格式 MMM DD HH:mm
 * @param time 秒
 * @returns
 */
export function timeFormat(time: number) {
  if (dayjs.locale() === 'zh-cn') {
    return dayjs(time * 1000).format('MMM D日 HH:mm')
  }
  return mttTimeFormat(time, 'MM-DD HH:mm')
}
export function timeOtherFormat(time: number, format: string = 'MM/DD HH:mm') {
  return mttTimeFormat(time, format)
}

/** YYYY-MM-DD HH:mm:ss */
export function timeFormatA(time: number) {
  return mttTimeFormat(time, YYYYMMDDHHmmss)
}

export function timeFormatNew(time: number, format: string = YYYYMMDDHHmm) {
  return mttTimeFormat(time, format)
}

/**
 * 格式化时间格式通用函数
 * @param time 需要转换的时间，支持格式："秒"级时间戳 / "毫秒"级时间戳 / 原生 Date / dayjs.DayJS
 * @param format 需要输出的目标格式（适配泰语时间）
 * @returns
 */
export function mttTimeFormat(time: number | dayjs.Dayjs | Date | undefined, format: string = YYYYMMDDHHmm) {
  if (!time) {
    return ''
  }
  let formatStr = format
  // const lang = 'en' // getLang()
  // if (lang === 'th') {
  //   // 泰语时间格式是相反的
  //   formatStr = format
  //     .replaceAll('YYYY-MM-DD', 'DD/MM/YYYY')
  //     .replaceAll('YYYY-MM', 'MM/YYYY')
  //     .replaceAll('MM-DD', 'DD/MM')
  //     .replaceAll('MM/DD', 'DD/MM')
  //     .replaceAll('MM DD', 'DD/MM')
  // }
  if (typeof time === 'number') {
    if (time.toString().length === 10) {
      // 长度等于10位的，表示“秒”级时间戳，需转换为"毫秒"级 。例：1728388510 -> 1728388510000
      return dayjs(time * 1000).format(formatStr)
    } else {
      return dayjs(time).format(formatStr)
    }
  } else if (time instanceof Date) {
    return dayjs(time).format(formatStr)
  } else if (typeof time?.format === 'function') {
    return time.format(formatStr)
  }
  try {
    return dayjs(time).format(formatStr)
  } catch (error) {}
  return ''
}

function addZero(time: number) {
  let str = time.toString()
  if (time < 10) {
    str = '0' + time
  }
  return str
}

export function changeTimeBySecond(second: number) {
  let hourTime = 0
  let minuteTime = 0
  let secondTime = 0
  if (second > 60) {
    //如果秒数大于60
    minuteTime = Math.floor(second / 60)
    secondTime = Math.floor(second % 60)
    if (minuteTime >= 60) {
      //如果分钟大于60
      hourTime = Math.floor(minuteTime / 60)
      minuteTime = Math.floor(minuteTime % 60)
    } else {
      hourTime = 0
    }
  } else {
    hourTime = 0
    minuteTime = 0
    if (second == 60) {
      //如果秒数等于60
      minuteTime = 1
      secondTime = 0
    } else {
      secondTime = second
    }
  }
  const timeResult = addZero(hourTime) + ':' + addZero(minuteTime) + ':' + addZero(secondTime)
  return timeResult
}

/**
 * 是否超过天数
 * @param day 天数
 */
export function isExceededDay(day: number, timestamp: number) {
  const seconds = day * 24 * 60 * 60
  const nowSeconds = dayjs().unix()

  return nowSeconds - timestamp > seconds
}

/**
 * 剩余时间 xx天xx时
 */
export function getRemainingDate(futureTime: number) {
  if (!futureTime) {
    return ''
  }

  const nowUnixTime = dayjs().unix()

  if (nowUnixTime > futureTime) {
    return ''
  }

  const day = 24 * 60 * 60
  const hour = 60 * 60
  const minute = 60

  const diffSeconds = futureTime - nowUnixTime

  const days = Math.floor(diffSeconds / day) || 0
  const hours = Math.floor((diffSeconds % day) / hour) || 0
  const minutes = Math.ceil(((diffSeconds % day) % hour) / minute) || 0

  let text = ''

  if (days > 0) {
    text += `${days}D`
  }

  if (hours > 0) {
    text += `${days}H`
  }

  text += `${minutes}M`

  return text
}
